import moment, { Moment } from 'moment';
import { DateFormat, IndexedArray, Project } from '@common/types';
import { createArrayFromIndexedArray } from '@common/utils/helpers/array/create-array-from-indexed-array';

export const filterByDateProjects = (projects: IndexedArray<Project> | Array<Project>, date: Moment | null) => {
  return createArrayFromIndexedArray(projects).filter(
    ({ Start }) => moment.unix(Number(Start)).format(DateFormat.DDMMYYYYPeriod) === moment(date).format(DateFormat.DDMMYYYYPeriod)
  );
};
